import React from 'react';

const SVGStar = (props) => {
	return (
		<svg version="1.1" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path fill="transparent" stroke="#ddad7f" transform="matrix(2.9415 0 0 3.065 41.525 44.987)" d="m117.49 137.24-44.651-23.39-44.582 23.522 8.4472-49.694-36.148-35.131 49.872-7.3224 22.241-45.234 22.375 45.168 49.893 7.1743-36.043 35.238z" strokeLinecap="round" strokeLinejoin="round" strokeWidth="29.345" />
		</svg>
	);
}

export default SVGStar;
